import { FormEvent } from "react";

export default function ClassicButton({
	buttonText,
	buttonIcon,
	buttonAriaLabel = "button",
	buttonType = "button",
	showArrow = false,
	showButtonShadow = true,
	bgColorScheme = "orange", 
	textColorScheme = "white", 
	classes="px-6 sm:px-6.5 md:px-8 2xl:px-[2.2vw]",
	onClick = () => {},
	onSubmit = () => {},
	children,
}: {
	buttonText?: string;
	buttonIcon?: any;
	buttonAriaLabel?: string;
	buttonType?: "button" | "submit";
	showArrow?: boolean;
	showButtonShadow?: boolean;
	bgColorScheme?: "orange" | "white" | "transparent" | "dark";
	textColorScheme?: "white" | "black";
	classes?: string;
	onClick?: () => void;
	onSubmit?: ( e: FormEvent<HTMLButtonElement>) => void;
	children?: React.ReactNode;
}) {

	const bgColors = {
        orange: "bg-[#ff9e0c] active:bg-[#ffa60c] hover:bg-[#ffb800]",
        white: "bg-white active:bg-gray-200 hover:bg-gray-100",
		transparent: "bg-transparent",
		dark: "bg-[#464646] active:bg-[#631717] hover:bg-[#7F1D1D]",
    };

	const textColors = {
		white: "text-white",
		black: "text-black",
		transparent: "text-transparent",
	};

	const shadows = {
		orange: "shadow-[1px_10px_18px_2px_rgba(255,158,12,0.55)] 2xl:[box-shadow:0.1vw_0.7vw_1.2vw_0.2vw_rgba(255,158,12,0.55)]",
		white: "shadow-[1px_10px_18px_2px_rgba(255,255,255,0.55)] 2xl:[box-shadow:0.1vw_0.7vw_0.6vw_0.2vw_rgba(255,255,255,0.55)]",
		transparent: "shadow-[1px_10px_18px_2px_rgba(255,255,255,0)] 2xl:[box-shadow:0.1vw_0.7vw_0.6vw_0.2vw_rgba(255,255,255,0)]",
		dark: "shadow-[1px_10px_18px_2px_rgba(70,70,70,0.55)] 2xl:[box-shadow:0.1vw_0.7vw_0.9vw_0.2vw_rgba(70,70,70,0.55)]",
	}


	return (
		<>
			<button
				type={buttonType}
				className={`relative
					rounded-full ${bgColors[bgColorScheme]} ${textColors[textColorScheme]} ${showButtonShadow ? shadows[bgColorScheme] : ""} }
					text-xs sm:text-sm lg:text-base xl:text-lg 2xl:text-[1.4vw] font-bold
					py-2.5 sm:py-3 md:py-4 2xl:py-[1vw]
					${ classes } 
					w-fit h-12 sm:h-[unset] flex gap-2 items-center group select-none whitespace-nowrap cursor-pointer
					transition-colors duration-300 
				`}
				aria-label={buttonAriaLabel}
				title={buttonText || buttonAriaLabel}
				onClick={onClick}
				onSubmit={onSubmit}
			>
				{buttonText && (<span>{buttonText}</span>)}
				{buttonIcon && (<span className="bg-transparent border-0 min-w-[1rem]">{buttonIcon}</span>)}
				{showArrow && (
					<span className="transform transition-transform duration-300 group-hover:translate-x-1">
						➔
					</span>
				)}
				{children}
			</button>
		</>
	);
}